import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MapBroadcastService implements OnDestroy {

  private channel = new BroadcastChannel('jobs_map_channel');

  //jobs$ = new Subject<any[]>();
  private jobsSubject = new BehaviorSubject<{ jobs: any[], filtered: boolean } | null>(null);
  jobs$ = this.jobsSubject.asObservable();
  mapReady$ = new Subject<void>();

  constructor() {
   this.channel.onmessage = (event) => {
      if (event.data?.type === 'JOBS_UPDATE') {
        this.jobsSubject.next({ jobs: event.data.jobs, filtered: event.data.filtered ?? false });
      }

      if (event.data?.type === 'MAP_READY') {
        this.mapReady$.next();
      }
    };
  }

  sendJobs(jobs: any[], filtered = false) {
    this.jobsSubject.next({ jobs, filtered });
    this.channel.postMessage({ type: 'JOBS_UPDATE', jobs, filtered });
  }

  // sendJobs(jobs: any[]) {
  //   this.channel.postMessage({
  //     type: 'JOBS_UPDATE',
  //     jobs
  //   });
  // }

  notifyMapReady() {
    this.channel.postMessage({
      type: 'MAP_READY'
    });
  }

  ngOnDestroy() {
    this.channel.close();
  }
}